import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms'; 
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
// 🚀 INYECTADO: Desbloquea la directiva [(ngModel)] para la caja de texto del usuario
import { RouterLink } from '@angular/router';

import { UserAdd } from '../user-add/user-add'; 
import { UserEdit } from '../user-edit/user-edit'; 
import { AuthService } from '../../Service/auth'; // Ajusta la ruta de tus carpetas
import { ToastService } from '../../Service/toast-service';
import { PersonalAdd } from '../personal-add/personal-add'; // 🚀 Ajusta la ruta a tu carpeta

// 💡 Interfaz local de tipado simétrica a tu UserDTO de Spring Boot
export interface UserSystem {
  userId: string;
  an8: number;
  nameAlpha: string; // Nombre real extraído de la f0101
  enabled: boolean;
  rolesUdcIds: number[];
  rolesNombres?: string[];
}

@Component({
  selector: 'app-user-list',
  standalone: true,
  imports: [
    CommonModule,     
    MatDialogModule,
    FormsModule // 🚀 LA CLAVE MÁSTER PARA TU MOTOR DE BÚSQUEDA DE SEGURIDAD
  ],
  templateUrl: './user-list.html',
  styleUrl: './user-list.css',
})
export class UserList implements OnInit {
  
  // 💡 TOTALMENTE HOMOLOGADO: Ambos arreglos usan tu interfaz UserSystem
  users: UserSystem[] = [];         // El catálogo maestro original
  usersFiltrados: UserSystem[] = []; // El arreglo secundario que recortará el buscador
  
  filtroUserTexto: string = '';
  filtroUserRol: string = '';

  filtroTexto: string = '';

  // =========================================================================
  // 🎛️ VARIABLES CORE PARA TU NUEVA PAGINACIÓN REACTIVA DE USUARIOS
  // =========================================================================
  paginaActual: number = 1;
  registrosPorPagina: number = 10; // Límite exacto de renglones por rejilla
  totalPaginas: number = 1;

  // Hacemos visible la librería Math para que la plantilla HTML no arroje errores ts(2339)
  protected readonly Math = Math;  

  constructor(
    // private userService: UsersService, // 💡 Cuando tengas tu servicio HTTP de usuarios listo, lo inyectas aquí
    public authService: AuthService,
    public toastService: ToastService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    // 🛡️ RECEPTOR DE ESTADOS ASÍNCRONOS DE SEGURIDAD (CICLO SEGURO CSR)
    const estadoRuta = typeof window !== 'undefined' ? history.state : null;

    if (estadoRuta && estadoRuta['mostrarAlertaExito']) {
      this.toastService.showSuccess('Acceso Autorizado', estadoRuta['mensajeToast']);
      this.cdr.detectChanges(); // Fuerza a Angular a pintar el Toast en este microsegundo
    }
    this.listUsers(); // Tu llamada tradicional de carga por red
  }

   /**
   * 🔄 REPETICIÓN DE RENDIMIENTO: Descarga el catálogo de cuentas
   * conectadas a las tablas f0002_user y f0101, traduciendo IDs a Roles legibles.
   */
  listUsers(): void {
    console.log('>>> [SECURITY JDE] Descargando matriz de usuarios real desde MySQL...');
    
    this.authService.getAllUsuariosMaster().subscribe({
      next: (data: any[]) => {
        // Mapeamos los datos asegurando el match milimétrico con la interfaz expandida
        this.users = data.map(u => {
          const idsUdc: number[] = u.rolesUdcIds || [];
          
          // =========================================================================
          // 🚀 TRADUCTOR DE ROLES EN CALIENTE (ASOCIACIÓN DIRECTA DE UDCs)
          // SOLUCIÓN: Iteramos sobre los IDs numéricos que inyecta tu roleRepository
          // y los convertimos al formato string estándar que espera tu negocio.
          // =========================================================================
          const nombresTraducidos = idsUdc.map((id: number) => {
            if (id === 471) return 'ROLE_ADMIN';
            if (id === 472) return 'ROLE_ASESOR';
            if (id === 473) return 'ROLE_MECHANIC';
            if (id === 474) return 'ROLE_SUPPLIER';
            if (id === 475) return 'ROLE_PURCHASE';
            return `UDC_${id}`; // Fallback por si tienes algún rol personalizado extra
          });

          return {
            userId: u.userId,
            an8: u.an8,
            nameAlpha: u.nameAlpha || 'EMPLEADO SIN NOMBRE',
            enabled: u.enabled,
            rolesUdcIds: idsUdc,
            rolesNombres: nombresTraducidos // 🟢 Sella los textos legibles en el payload
          };
        });

        // Poblamos el array secundario del buscador para mantener activo tu motor de filtros
        this.usersFiltrados = [...this.users];

        console.log('>>> [SECURITY JDE] Grid de seguridad poblado en vivo con roles legibles.');
        
        // Forzamos el redibujado inmediato de la UI
        this.cdr.markForCheck();
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error('Error crítico al descargar usuarios de la f0002_user:', err);
        this.toastService.showDanger(
          'Fallo de Sincronización',
          'No se pudo establecer conexión con el catálogo de seguridad. Verifique el puerto 8085.'
        );
        this.cdr.detectChanges();
      }
    });
  }

  /**
   * ✏️ CONEXIÓN MODAL ATÓMICA:
   * Abre el panel flotante de UserEdit inyectando el perfil del operador.
   */
  editUser(usuario: UserSystem): void {
    const dialogRef = this.dialog.open(UserEdit, {
      data: { ...usuario }, // Enviamos una clonación limpia de seguridad
      width: '500px',
      panelClass: 'custom-security-dialog'
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      // Validamos que el administrador haya guardado cambios reales
      if (result && result.userId) {
        
        // 1. Buscamos el registro en el arreglo de memoria para actualizar en caliente
        const index = this.users.findIndex(u => u.userId === result.userId);
        if (index !== -1) {
          // Asignación reactiva directa para redibujar el renglón en un milisegundo
          this.users[index] = { ...result };
        }

        // 2. Rompemos el congelamiento visual de la UI
        this.cdr.markForCheck();
        this.cdr.detectChanges();

        // 3. ¡EL TOAST VERDE DE ÉXITO BRINDA EN LA ESQUINA!
        this.toastService.showSuccess(
          'Seguridad Actualizada',
          `Los privilegios y accesos para el usuario [${result.userId.toUpperCase()}] se sincronizaron con éxito.`
        );

        // 4. Refrescamos desde el servidor para sincronizar auditorías físicas de MySQL
        this.listUsers();

      } else {
        console.warn('>>> [SECURITY JDE] El panel de roles se cerró sin realizar modificaciones.');
      }
    });
  }

  trackByUserId(index: number, user: UserSystem): string {
    return user.userId;
  }

   /**
   * 🚀 MOTOR DE BÚSQUEDA REACTIVO EN CALIENTE (CORREGIDO E INMUNE A ID-HARDCODING):
   * Filtra la rejilla basándose en los textos normalizados, evitando colisiones de IDs físicos.
   */
  filtrarUsuarios(): void {
    const textoBusqueda = this.filtroUserTexto.trim().toUpperCase();
    const rolBusqueda = this.filtroUserRol; // Contiene 'ROLE_ADMIN', 'ROLE_ASESOR', etc.

    this.usersFiltrados = this.users.filter((u: UserSystem) => {
      
      // 1. Coincidencia por Texto Libre (Login ID o Nombre completo de la f0101)
      const cumpleTexto = !textoBusqueda ? true : 
        ((u.userId && u.userId.toUpperCase().includes(textoBusqueda)) ||
         (u.nameAlpha && u.nameAlpha.toUpperCase().includes(textoBusqueda)));

      // 2. Coincidencia por Rol (Evaluando de forma segura tus strings traducidos 'rolesNombres')
      // 🛡️ SOLUCIÓN: Al usar el array de texto, desvanecemos el error de los IDs 464/471 del catálogo MySQL.
      const cumpleRol = !rolBusqueda ? true : 
        (u.rolesNombres && u.rolesNombres.includes(rolBusqueda));

      return cumpleTexto && cumpleRol;
    });

    this.paginaActual = 1;
    this.calcularTotalPaginas();
    this.cdr.detectChanges(); 
  }

  calcularTotalPaginas(): void {
    this.totalPaginas = Math.ceil(this.usersFiltrados.length / this.registrosPorPagina) || 1;
    this.cdr.detectChanges();
  }

  cambiarPagina(nuevaPagina: number): void {
    if (nuevaPagina >= 1 && nuevaPagina <= this.totalPaginas) {
      this.paginaActual = nuevaPagina;
      console.log('>>> [PREFS JDE] Conmutando bitácora de usuarios a la página:', this.paginaActual);
      this.cdr.detectChanges();
    }
  }

  /**
   * 💡 LA COMPUERTA RECTANGULAR REACTIVA (CON TIPADO ESTRICTO):
   * Recorta el array garantizando la protección de propiedades en la plantilla HTML.
   */
  get usersPaginados(): UserSystem[] { // 🛠️ Saneado: Cambiado de any[] a UserSystem[]
    const inicio = (this.paginaActual - 1) * this.registrosPorPagina;
    const fin = inicio + this.registrosPorPagina;
    return this.usersFiltrados.slice(inicio, fin);
  }  

  abrirAltaModal(): void {
    console.log('🚀 [SaaS Seguridad] Lanzando ventana modal UserAdd...');

    // Abrimos el modal flotante fijando un ancho elegante de 550px a pantalla limpia
    const dialogRef = this.dialog.open(UserAdd, { width: '750px', disableClose: true });

    dialogRef.afterClosed().subscribe((result: any) => {
      console.log('🚪 [SaaS Seguridad] Ventana Modal de Usuario Cerrada. Result:', result);

      // 🛡️ ADUANA UX DE SALIDA SEGURA: Si presionó Cancelar o cerró la "X", 'result' es false.
      // Abortamos de inmediato en absoluto silencio técnico y libre de falsos Toasts.
      if (result === false || result === null || result === undefined) {
        console.log('❌ [SaaS Seguridad] Alta cancelada por el administrador. Saliendo sin alertas.');
        return;
      }

      // Si pasó la aduana, significa que sí guardó de forma legítima. Limpiamos buscador superior.
      this.filtroTexto = '';

      // Disparamos tu exitoso Toast flotante verde en caliente sobre el listado de fondo
      this.toastService.showSuccess(
        'Acceso Autorizado', 
        `El nuevo usuario ha sido registrado e indexado con éxito en tu base de datos.`
      );

      console.log('📡 [SaaS Seguridad] Disparando refresco automático directo por red...');
      this.listUsers(); // Tu llamada tradicional que descarga las cuentas frescas
    });
  }

  // [Pega este método justo debajo de abrirAltaModal()]
  abrirPersonalModal(): void {
    console.log('🚀 [SaaS Seguridad] Lanzando ventana modal PersonalAdd (F0101)...');

    const dialogRef = this.dialog.open(PersonalAdd, { 
      width: '800px', 
      disableClose: true 
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      console.log('🚪 [SaaS Seguridad] Ventana Modal de Personal Cerrada. Result:', result);

      // Si el administrador canceló la operación, abortamos en silencio
      if (!result || result === false) {
        console.log('❌ [SaaS Seguridad] Alta de personal cancelada. Saliendo sin alertas.');
        return;
      }

      // =========================================================================
      // 🎉 VÍNCULO CORPORATIVO: Capturamos el éxito e inyectamos el Toast reactivo
      // =========================================================================
      if (result.status === 'SUCCESS' || result.an8) {
        
        // Disparamos tu Toast verde con los datos reales devueltos por MySQL
        this.toastService.showSuccess(
          'Identidad Registrada',
          `La identidad física de [${result.nameAlpha || 'NUEVO PERSONAL'}] ha sido guardada en el Address Book con el código AN8: ${result.an8}.`
        );

        // Forzamos a Angular a redibujar el contenedor de Toasts en este microsegundo
        this.cdr.markForCheck();
        this.cdr.detectChanges();
        
        console.log('📡 [SaaS Seguridad] Toast de éxito desplegado sobre el listado de usuarios.');
      }
    });
  }

}
